require('./contractEasyLoanErrorStep.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { recordPage, recordLinkV2 } = require('utilities/tagging');
// @ commons
const WizardError = require('components/commons/wizardError/wizardError');
//@analytics
const {
    analyticsId,
    catalogue,
} = require('../analytics/contractEasyLoan.tracking');

const ContractEasyLoanErrorStep = ({ phoneNumber, immContractEasyLoan, onLeave }) => {
    const title = formatText('contractEasyLoanError-title');
    const goBackLink = {
        label: formatText('contractEasyLoanError-goBackLinkText').toUpperCase(),
        url: 'myprofile/'
    };

    React.useEffect(() => {
        recordLinkV2(
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_3_SUCCESS]()
        );
        recordPage(
            catalogue[analyticsId.CONTRACT_EASY_LOAN_WIZARD_ERROR]({
                data: !!immContractEasyLoan && immContractEasyLoan.get("minTae"),
                errorMessage: title,
            })
        );
    }, []);
    React.useEffect(() => {
        return () => {
            onLeave();
        }
    }, []);
    return (
        <article className="contract-easy-loan-error-step row no-gutter">
            <div className="col-xs-12">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackLink}
                >
                    <section className="row">
                        <FormattedText value="contractEasyLoanError-messageOne" className="contract-easy-loan-error-step__block" />
                        <FormattedText value="contractEasyLoanError-messageTwo" className="contract-easy-loan-error-step__block" />
                        <i className="icon-s-llamar contract-easy-loan-error-step__icon"></i>
                        { phoneNumber }
                    </section>
                </WizardError>
            </div>
        </article>
    );
};

ContractEasyLoanErrorStep.propTypes = {
    phoneNumber: PropTypes.string.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
};

module.exports = ContractEasyLoanErrorStep;
